export default __webpack_public_path__ + "images/0x7f5c764cbc14f9669b88837ca1490cca17c31607.png";